import K from "./K";
import router from '../router/index'
var k = new K()

export default class HTFetch
{
    HTStatus = null;                // referencia a HTStatus (se carga en el mount de HTStatus)

    /** Obtener configuración para saber dónde buscar la API */
    async getWebAppConfig(handler) {
        await fetch(`/webappconfig.json`, {})
            .then(response => {
                if (response.status == 200)   // OK
                    return response.json();                 // devuelve Promise (que tomará el then del que llama)
            })
            .then(data => {
                handler(data);
            });
    }

    //refresh token
    async ChkJWT(handler) {

        /*if (localStorage.user_logged !== 'true') {
            //this.showError('Sesión vencida', true);
            return false;
        }*/

        return fetch(            // llamar a ping
            `${k.webapi_URL}token_emailai/refresh/`,
            {
                method: 'post',
                mode: "cors",
                referrerPolicy: k.HEADER_STRICT_ORIGIN,
                headers: { "Content-Type": k.HEADER_APP_JSON },
                body: JSON.stringify({ 'refresh': localStorage.rt })
            })
            .then(r => {
                if (r.status == 200) {
                    //r.json = localStorage.ut;
                    //console.log(r)
                    if (!location.href.includes('database'))
                        location.reload()
                    if (handler) handler();
                    return r.json();
                } else {
                    this.LogOut() 
                }
                throw new Error();
            })
            .then((data) => {
                localStorage.ut = data.access
            });
    
    }

    async MIFetch(
        url,
        config
    ) {
        return fetch(url, config)
            
            .then(r => {

                if (r.status === 401) {
                    if (!location.href.includes('reset-password-after-mail')) {
                        this.ChkJWT()
                    }
                }
                
                /*if (r.status !== 200 && r.status !== 201 && r.status !== 303) {
                    
                    return r.json() // Convert the response to JSON
                        .then(function(data) {
                            return { status: r.status, data: data };
                        });
                }*/
                
                if (r.status) {
                    
                    return r.json()
                        .then(function(data) {
                            return { status: r.status, data: data };
                        });
                }
                
                //throw new Error();
            })
            .then(data => data)
            .catch(error => {
                console.log(error)
            });
    }

    async Login(username, password, handler) {
        
        let data = {
            method: 'post',
            mode: "cors",
            referrerPolicy: k.HEADER_STRICT_ORIGIN,
        };
        
        data.body = JSON.stringify({ "username": username, "password": password })
        data.headers = {
            "Content-Type": k.HEADER_APP_JSON
        };

        await this.MIFetch(
            `${k.webapi_URL}token_emailai/`, data
            )
            .then(data => {
                    
                handler(data);
            });
    }

    /**
     * 
     * @param {any} controller controller de la API
     * @param {any} metodo
     * @param {any} handler
     */
    async HSFetch(controller, method, handler, http_method, answer, body = null) {

        let data = {
            method: http_method,
            mode: "cors",
            referrerPolicy: k.HEADER_STRICT_ORIGIN,
        };

        
        if (body) {
            data.body = JSON.stringify(body);
            data.headers = {
                'Authorization': 'Bearer ' + localStorage.ut,
                "Content-Type": k.HEADER_APP_JSON,
            };
        }
        else
            data.headers = { 'Authorization': 'Bearer ' + localStorage.ut, };
        
        await this.MIFetch(`${k.webapi_URL}${controller}${method}`, data)
            .then(data => {
                handler(data);
            });
    }

    //para enviar files
    async HSFileFetch(controller, method, handler, http_method, answer, body = null) {

        let data = {
            method: http_method,
            mode: "cors",
            referrerPolicy: k.HEADER_STRICT_ORIGIN,
        };

        function generateBoundary() {
            const boundaryLength = 16; // Length of the boundary in bytes
            const boundaryBytes = new Uint8Array(boundaryLength);
            crypto.getRandomValues(boundaryBytes);
            let boundary = '';
            for (let i = 0; i < boundaryLength; i++) {
                boundary += boundaryBytes[i].toString(16).padStart(2, '0');
            }
            return boundary;
        }
        
        const boundary = generateBoundary();
        
        if (body) {
            data.body = body//JSON.stringify(body);
            data.headers = {
                'Authorization': 'Bearer ' + localStorage.ut,
                "Content-Type": `multipart/form-data; boundary=${boundary}`//k.HEADER_APP_JSON,
            };
        }
        else
            data.headers = { 'Authorization': 'Bearer ' + localStorage.ut, };
        
        await this.MIFetch(`${k.webapi_URL}${controller}${method}`, data)
            .then(data => {
                handler(data);
            });
    }

    //para bajar streams
    async StreamFetch(controller, method, handler, http_method, answer, body = null) {

        let data = {
            method: http_method,
            mode: "cors",
            referrerPolicy: k.HEADER_STRICT_ORIGIN,
        };
        
        if (body) {
            data.body = JSON.stringify(body);
            data.headers = {
                'Authorization': 'Bearer ' + localStorage.ut,
                "Content-Type": k.HEADER_APP_JSON,
            };
        }
        else
            data.headers = { 'Authorization': 'Bearer ' + localStorage.ut, };

        let speedPerLetter = 0; // velocidad por letra en milisegundos
        let endpointUrl = 'https://tu_endpoint.com'; // tu URL de endpoint aquí
        let outputElementId = 'elementId'; // el id del elemento del DOM donde se mostrará el texto

        async function streamData() {
            const response = await fetch(endpointUrl);

            if (!response.body) {
                throw new Error('El servidor no responde o el stream no es soportado');
            }

            const reader = response.body.getReader();
            const stream = new ReadableStream({
                start(controller) {
                    read();
                    async function read() {
                        const { done, value } = await reader.read();
                        if (done) {
                            controller.close();
                            return;
                        }

                        controller.enqueue(value);
                        read();
                    }
                }
            });

            const textDecoder = new TextDecoder();
            const data = stream.getReader();

            // eslint-disable-next-line no-constant-condition
            while (true) {
                const { done, value } = await data.read();
                if (done) {
                    break;
                }

                let chunk = textDecoder.decode(value);
                
                for(let character of chunk) {
                    await sleep(speedPerLetter);
                    document.getElementById(outputElementId).textContent += character;
                }
            }
        }

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        streamData().catch(console.error);
    }

    async HSFetchSinTkn(controller, method, handler, http_method, answer, body = null) {

        let data = {
            method: http_method,
            mode: "cors",
            referrerPolicy: k.HEADER_STRICT_ORIGIN,
        };
        
        if (body) {
            data.body = JSON.stringify(body);
            data.headers = {
                "Content-Type": k.HEADER_APP_JSON,
            };
        }
        
        if (answer == "json")
            await this.MIFetch(`${k.webapi_URL}${controller}${method}`, data)
                .then(data => {
                    handler(data);
                });
    }

    LogOut() {
        localStorage.removeItem(k.LS.user_expiration);
        localStorage.removeItem(k.LS.user_token);
        localStorage.removeItem(k.LS.refresh_token);
        localStorage.clear()
        localStorage.user_logged = false;
        
        router.push({ name: 'Sign In'})
    }

    //zona de llamadas 
    async crearTexto(body, handler) {
        await this.HSFetch("content/create_text/", "", handler, "post", "", body);
    }

    async userInfo(handler) {
        await this.HSFetch("business/user-info/", "", handler, "get", "");
    }

    //pasarela de pago
    async newClient(body, handler) {
        await this.HSFetchSinTkn("business/new-client/", "", handler, "post", "json", body);
    }

    async sendResetPass(body, handler) {
        await this.HSFetchSinTkn("business/password/send/", "", handler, "post", "json", body);
    }

    async resetPassFromEmail(body, handler) {
        await this.HSFetchSinTkn("business/password/reset/", "", handler, "post", "json", body);
    }

    async changePass(body, handler) {
        await this.HSFetch("business/password/change/", "", handler, "post", "json", body);
    }

    async stripeCheckout(membership, handler) {
        await this.HSFetch("business/stripe/checkout/?membership=" + membership, "", handler, "get", "");
    }

    async checkPayment(handler) {
        await this.HSFetch("business/stripe/check-payment/", "", handler, "get", "");
    }

    //dashboard
    async dashboard(handler) {
        await this.HSFetch("dashboard/general/", "", handler, "get", "");
    }

    async deleteUser(body, handler) {
        await this.HSFetch("business/user/", "", handler, "delete", "json", body);
    }

    async newUser(body, handler) {
        await this.HSFetch("business/user/", "", handler, "post", "json", body);
    }

    async newTeam(body, handler) {
        await this.HSFetch("business/collection/", "", handler, "post", "json", body);
    }

    async deleteTeam(body, handler) {
        await this.HSFetch("business/collection/", "", handler, "delete", "json", body);
    }

    //database
    async outlookCredentials(body, handler) {
        await this.HSFetch("actions/credentials-outlook/", "", handler, "post", "json", body);
    }

    async gmailImport(body, handler) {
        await this.HSFetch("actions/credentials-gmail/", "", handler, "post", "json", body);
    }

    async getDB(page, query, token, handler) {
        await this.HSFetch(`actions/emails/?page=` + page + `&query=` + query + `&collection=` + token, "", handler, "get", "");
    }

    async newEmail(body, handler) {
        await this.HSFetch("actions/email/", "", handler, "post", "json", body);
    }

    async newEmailCSV(body, handler) {
        await this.HSFetch("actions/email-csv/", "", handler, "post", "json", body);
    }

    async outlookCSV(body, handler) {
        await this.HSFetch("actions/email-csv-outlook/", "", handler, "post", "json", body);
    }

    async deleteEmail(body, handler) {
        await this.HSFetch("actions/email/", "", handler, "delete", "json", body);
    }

    async getDocs(token, handler) {
        await this.HSFetch(`documents/list/?collection=` + token, "", handler, "get", "");
    }

    async postDoc(body, handler) {
        await this.HSFetch("documents/", "", handler, "post", "json", body);
    }

    async deleteDoc(body, handler) {
        await this.HSFetch("documents/", "", handler, "delete", "json", body);
    }

    async getWebs(token, handler) {
        await this.HSFetch(`webs/?collection=` + token, "", handler, "get", "");
    }

    async postWeb(body, handler) {
        await this.HSFetch("webs/", "", handler, "post", "json", body);
    }

    async deleteWeb(body, handler) {
        await this.HSFetch("webs/", "", handler, "delete", "json", body);
    }

    async getQuestions(token, handler) {
        await this.HSFetch(`questions/?collection=` + token, "", handler, "get", "");
    }

    async postQuestion(body, handler) {
        await this.HSFetch("questions/", "", handler, "post", "json", body);
    }

    async postFaqBatch(body, handler) {
        await this.HSFetch("questions/excel/", "", handler, "post", "json", body);
    }

    async deleteQuestion(body, handler) {
        await this.HSFetch("questions/", "", handler, "delete", "json", body);
    }

    //generation
    /*async generation(body, handler) {
        await this.HSFetch("actions/generate/", "", handler, "post", "json", body);
    }*/

    async generation(body, handler) {
        await this.StreamFetch("actions/generate/", "", handler, "post", "json", body);
    }

    async feedback(body, handler) {
        await this.HSFetch("actions/feedback/", "", handler, "post", "json", body);
    }

    //billing
    async getStripeData(handler) {
        await this.HSFetch('business/user-client-portal/', "", handler, "get", "");
    }

    //tutorials
    async tutorials(handler) {
        await this.HSFetch('tutorials/list/', "", handler, "get", "");
    }

    //connections
    async dataGenerated(handler) {
        await this.HSFetch('business/count-data/', "", handler, "get", "");
    }

    //reports
    async getReports(token, handler) {
        await this.HSFetch(`reports/?collection=${token}`, "", handler, "get", "");
    }

    async postReport(body, handler) {
        await this.HSFetch("reports/", "", handler, "post", "json", body);
    }

    async deleteReport(body, handler) {
        await this.HSFetch("reports/", "", handler, "delete", "json", body);
    }
}